import { render, staticRenderFns } from "./bStore_setup_booking.vue?vue&type=template&id=a22ebd76&scoped=true"
import script from "./bStore_setup_booking.vue?vue&type=script&lang=js"
export * from "./bStore_setup_booking.vue?vue&type=script&lang=js"
import style0 from "./bStore_setup_booking.vue?vue&type=style&index=0&id=a22ebd76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22ebd76",
  null
  
)

export default component.exports